import { assignIfExists, findMatch, removeItemByCode } from '@/utils/resultsHelper';
import { responseError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import {
  datasetConversionState,
  datasetValidationState, findDatasetData,
  upsertConversionDictionary,
  upsertValidationDictionary,
} from './state';
import actions from '../constants';

const convertDatasetData = withDraft((draft, action) => {
  const item = findDatasetData(draft, action);
  if (item) {
    item.saveStatus = states.PENDING;
    item.saveErrors = [];
  } else {
    draft.dataManagement[action.category].results.push({
      ...datasetConversionState(),
      code: action.code,
      saveStatus: states.PENDING,
    });
  }
});

const convertDatasetDataSuccess = withDraft((draft, action) => {
  const item = findDatasetData(draft, action);
  item.errors = action.result.errors;
  item.saveStatus = states.SUCCESS;

  action.result.dictionaries_queued.forEach((dictionary) => {
    upsertConversionDictionary(item, dictionary);
    const conversionDictionary = findMatch(item.dictionaries, dictionary);
    assignIfExists(
      conversionDictionary,
      {
        saveStatus: states.SUCCESS,
        saveErrors: [],
      },
    );
  });
});

const convertDatasetDataError = withDraft((draft, action) => {
  const item = findDatasetData(draft, action);
  item.saveStatus = states.ERROR;
  item.saveErrors = [responseError(action)];
});

const validateDatasetData = withDraft((draft, action) => {
  const item = findDatasetData(draft, action);
  if (item) {
    item.readStatus = states.PENDING;
    item.readErrors = [];
  } else {
    draft.dataManagement[action.category].results.push({
      ...datasetValidationState(),
      code: action.code,
      readStatus: states.PENDING,
    });
  }
});

const validateDatasetDataSuccess = withDraft((draft, action) => {
  const item = findDatasetData(draft, action);
  item.valid = action.result.valid;
  item.name = action.result.name;
  item.status = action.result.status;
  item.errors = action.result.errors;
  item.readStatus = states.SUCCESS;
  item.data_model = action.result.data_model;
  action.result.dictionaries.forEach((dictionary) => {
    upsertValidationDictionary(item, dictionary.code);
    const validationDictionary = findMatch(item.dictionaries, dictionary.code);
    assignIfExists(
      validationDictionary,
      {
        name: dictionary.name,
        readStatus: states.SUCCESS,
        readErrors: [],
        valid: dictionary.valid,
        status: dictionary.status,
        errors: dictionary.errors,
      },
    );
  });
});

const validateDatasetDataError = withDraft((draft, action) => {
  const item = findDatasetData(draft, action);
  item.readStatus = states.ERROR;
  item.readErrors = [responseError(action)];
});

const hideValidationServerErrors = withDraft((draft, action) => {
  const item = findDatasetData(draft, action);
  if (item.readStatus === states.ERROR) {
    item.readErrors = action.errors;
  }
  const dictionaryError = (item?.dictionaries || []).find((d) => d.readStatus === states.ERROR);
  if (dictionaryError) {
    dictionaryError.readErrors = action.errors;
  }
});

const closeDatasetDataManagement = withDraft((draft, action) => {
  const item = findDatasetData(draft, action);
  if (item) {
    draft.dataManagement[action.category].results = removeItemByCode(
      draft.dataManagement[action.category].results,
      item,
    );
  }
});

export default {
  [actions.CONVERT_DATASET_DATA]: convertDatasetData,
  [actions.CONVERT_DATASET_DATA_SUCCESS]: convertDatasetDataSuccess,
  [actions.CONVERT_DATASET_DATA_ERROR]: convertDatasetDataError,
  [actions.VALIDATE_DATASET_DATA]: validateDatasetData,
  [actions.VALIDATE_DATASET_DATA_SUCCESS]: validateDatasetDataSuccess,
  [actions.VALIDATE_DATASET_DATA_ERROR]: validateDatasetDataError,
  [actions.HIDE_VALIDATION_SERVER_ERRORS]: hideValidationServerErrors,
  [actions.CLOSE_DATASET_DATA_MANAGEMENT]: closeDatasetDataManagement,
};
